module.exports = {
    startMeetingDownload: 0,
    standardRegistration: 1,
    singlePasswordRegistration: 2,
    passwordlessRegistration: 3,
};


/** WEBPACK FOOTER **
 ** ./src/constants/initial-cohort.js
 **/